import React from "react";
import { connect } from "react-redux";
import { getLycaSimProducts } from "../../modules/actions/productActions";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class BuySimMain extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      products : null
    };
    this.props.getLycaSimProducts();
  }

  render() {
    console.log(this.props);
    const { products } = this.props;
    const packages = products.length ? (
        products.map( product => {
          return (
              <span className="SimProducts mr-10" key={product._id}>
                  {/* <img src={product.image} width="100%" /> */}
                  {/* { product.shortDescription } */}
                  {/* { product.description } */}

                        <Link className="btn btn-white sim-product-btn" to={{
                            pathname: "/buy-sim/cart",
                            state : {
                                product : {...product},
                                anchor : 'SimSection'
                            }
                        }}>
                        { product.name } Plan <strong>${ product.globalPrice }</strong>
                        <p className="SimDate no-margin" style={{color: "red", fontWeight: "bold"}}>{product.description !== '' ? product.description : <br/>}</p>
                        </Link>
              </span>
          )
        })
    ) : null;

    return (
        <section className="BodyContainer" id="price">
            <div className="container">
                <div className="row sim-routes-wrapper">

                  <div className="col-md-4">
                    <img src="/images/121918-002.jpg"/>
                  </div>

                  {/*<div className="col-md-8 mt-5">*/}
                  <div className="col-md-8">
                    <div className="">
                      <div className="buy-sim-section">
                        <strong className="text-left">BUY SIM</strong>
                        <p className="text-left font15">Unlimited Calls and Texts in USA, Unlimited International Calls and Text to 75+ Countries.<br/>Please allow up to 7 days for delivery.</p>
                        <div style={{ clear: "both", height: "15px" }} />
                        <strong className="SimDescription">Lyca Mobile SIM Card Unlimited Talk, Text, and Data.</strong>
                        <div className="mt-3">{packages}</div>
                        <p className="SimShortDescription mt-4 font15">
                          This SIM card is not a self-activating SIM card.<br/>
                          Contact MightyWifi to activate. Activations may take up to 24 hours from the time of request.
                        </p>
                      </div>

                      {/*<div style={{ clear: "both", height: "20px" }} />
                      <div className="line" />

                      <div className="recharge-section-container">
                        <strong className="text-left">RECHARGE</strong>
                        <p className="SimShortDescription font15">
                          Recharge a T-Mobile SIM card purchased from anywhere.<br/>
                          Must be recharged within 3 days after the expiration date of the SIM.
                        </p>
                        <span className="SimProducts">
                            <Link className="btn btn-white btn-disabled" to="/recharge">
                                RECHARGE (COMING SOON)
                            </Link>
                        </span>
                      </div>*/}

                      {/*<div style={{ clear: "both", height: "45px" }} />
                      <div className="line" />

                      <div className="activate-section-container">
                        <strong className="text-left">ACTIVATE</strong>
                        <p className="SimShortDescription font15">
                          Activate a T-Mobile SIM card purchased from MightyWifi.
                        </p>

                        <span className="SimProducts">
                            <Link className="btn btn-white btn-disabled" to="/activate/sim">
                                ACTIVATE (COMING SOON)
                            </Link>
                        </span>
                      </div>*/}
                    </div>
                  </div>


              </div>
          </div>
    </section>
    )

  }


  /*getPerdayPrice(globalPrice, recurringPeriod) {
     let perDay = parseInt(globalPrice) / parseInt(recurringPeriod);
     //console.log("perDayPrice", perDay);
     return perDay.toFixed(2);
  }*/
}

BuySimMain.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    products: state.product.products,
  };
}

export default connect(
    mapStateToProps,
    { getLycaSimProducts }
)(BuySimMain);



// WEBPACK FOOTER //
// ./src/pages/buysim/BuySimMain.js